// 数据回收模块
export default {
    DataRecycling: {
        DataOverview: 'Data Overview',
        UpdatedOn: 'Updated On',
        NewToday: 'New Today',
        TotalDataVolume: 'Total Data Volume',
        AverageAnswerTime: 'Average Answer Time',
        TopicStatistics: 'Topic Statistics Topic',
        Export: 'Export',
        Operate: 'Operate',
        Preview: 'Preview',
        NumberOfRespondents: 'Number of Respondents',
        Download: 'Download',
        LoadMore: 'Load more',
        ExportType: 'Export Type',
        DataReport: 'Data report',
        ExportFormat: 'Export format',
        ExportCSV: 'Export CSV',
        ExportToExcel: 'Export to Excel',
        ExportWord: 'Export Word',
        Export: 'Export',
        ModifyQuestionnaireTip: 'Are you sure to modify this questionnaire? All data collected for this questionnaire will be stopped, and the answer sheet link will be temporarily closed!',
        ModificationPrompt: 'Modification prompt',
        CustomTitle: 'Custom Title',
        Pie: 'Pie',
        Histogram: 'Histogram',
        BarChart: 'Bar Chart',
        Ring: 'Ring',
        StackedBarChart: 'Stacked bar chart',
        StackedBarChart: 'Stacked bar chart',
        RadarChart: 'Radar chart',
        DataPreparationInProgress: 'Data preparation is underway and is expected to be completed in 5 minutes. go to',
        MyDownload: 'My Download',
        CanViewProgress: 'to view progress',
        Referrer: 'Referrer',
        ExportData: 'Export Data',
        ExportChart: 'Export Chart',
        PleaseSelect: 'Please Select',
        StackedColumnChart: 'Stacked Column chart',
        StackedBarChart: 'Stacked Bar chart',
        FoldLine: 'Fold Line',
        Filter: 'Filter',
        FilterMeetsTheFollowingCriteria: 'Filter meets the following criteria',
        Data: 'Data',
        AnswerToTheQuestion: 'Answer to the question',
        Delete: 'Delete',
        ShowSatisfaction: 'The display meets the following requirements',
        AnswerSheet: 'Answer Sheet',
        AddFilterCriteria: 'Add Filter Criteria',
        AnswerDate: 'Answer Date',
        To: 'To',
        StartDate: 'Start date',
        EndDate: 'End date',
        Clear: 'Clear',
        AllConditions: 'All conditions',
        AnyCondition: 'Any condition',
        All: 'All',
        Custom: 'Custom',
        Selected: 'Selected',
        NotSelected: 'Not selected',
        IsEmpty: 'Is empty',
        NotEmpty: 'Not empty',
        Contain: 'Contain',
        NotIncluded: 'Not included',
        OnlySelect: 'Only select',
        RestoreToDefault: 'After clearing the filter criteria, they will be restored to the default style',
        ConfirmEmptying: 'Confirm Emptying',
        LoadError: 'Load Error',
        QuestionBasedStatistics: 'Question Based Statistics',
        CrossAnalysis: 'Cross Analysis',
        SourceAnalysis: 'Source Analysis',
        SubtitleStatisticsCopy: 'Subtitle Statistics Copy',
        DataAnalysis: 'Data Analysis',
        CrossChart: 'Cross Chart',
        AddCrossAnalysis: 'Add Cross Analysis',
        NotCrossChart: 'There are currently no cross charts for this project',
        CrossChartsSupport: 'Cross charts only support single choice and multiple choice questions',
        AddCrossChart: 'Add Cross Chart',
        Argument: 'Argument',
        DependentVariable: 'Dependent Variable',
        HideChart: 'Hide Chart',
        HideTable: 'Hide Table',
        DisplaySettings: 'Display Settings',
        TotalNumberOfInterviewees: 'Total Number of Interviewees',
        RowPercentage: 'Row Percentage',
        ChartType: 'Chart Type',
        DisplayChart: 'Display Chart',
        DisplayTable: 'Display Table',
        DataScreening: 'Data Screening',
        NewDataAddedToday: 'New Data Added today',
        DataDetails: 'Data Details',
        SetUp: 'Set up',
        ExportAttachments: 'Export Attachments',
        ExportPicture: 'Export Picture',
        ExportRecording: 'Export Recording',
        ExportContent: 'Export Content',
        DataDetailsTable: 'Detailed Data Table',
        DataType: 'Data Type',
        RawData: 'Raw Data',
        CodedData: 'Coded Data',
        ExhibitionFormat: 'Exhibition Format',
        OneQuestionOneColumn: 'One Question, One Column',
        OneQuestionWithMultipleColumns: 'One Question with Multiple Columns',
        Details: 'Details',
        FullName: 'Full name',
        Age: 'Age',
        Year: 'Year',
        Gender: 'Gender',
        Education: 'Education',
        CellPhoneNumber: 'Cell Phone Number',
        Mailbox: 'Mailbox',
        ID: 'ID Number',
        Address: 'Address',
        SampleStatusName: 'Sample Status Name',
        ExportImageSettingsField: 'Export Image Settings Field',
        Route: 'Route',
        PleaseEnterContent: 'Please Enter Content',
        Name: 'Name',
        LabelTip: 'Note: Labels appear in pairs of square brackets. Please pay attention to the closure of square brackets when deleting path labels to ensure the legality of the generated path.',
        State: 'State',
        AllImages: 'All Images',
        CompleteImage: 'Complete Image',
        IdentifyingImages: 'Identifying Image',
        ExportRecordingSettingsFields: 'Export Recording Settings Fields',
        RecordAll: 'Record All',
        CompleteRecording: 'Complete Recording',
        IdentifyingRecordings: 'Identifying Recording',
        Source: 'Source',
        Interview: 'Interview',
        TelephoneSurveys: 'Telephone Surveys',
        SetDisplayFields: 'Set Display Fields',
        SampleFields: 'Sample Fields',
        WhetherToChoose: 'Choose',
        IsItFixedOnTheLeftSide: 'Left fixed',
        QuestionnaireFields: 'Fields',
        VisitorField: 'Visitor Field',
        GeographicalDistribution: 'Geographical Distribution',
        AccessingTheEnvironment: 'Accessing the Environment',
        ByDeviceType: 'By Device Type',
        ByBrowser: 'By Browser',
        ByOperatingSystem: 'By Operating System',
        Province: 'Province',
        SetDisplay: 'Set Display',
        NumberOfRespondents: 'Number of Respondents',
        ViewChartDisplaySettings: 'View Chart Display Settings',
        DisplayByTitle: 'Display by Title',
        Topic: 'Topic',
        DisplayAccordingToQuestionType: 'Display by Question Type',
        
        InputTypeQuestion: 'Input Question Type',
        MultipleChoiceQuestions: 'Multiple Choice',
        StarRating: 'Star Rating',
        TrueOrFalse: 'True or False',
        DateSelection: 'Date Selection',
        SortQuestion: 'Sorting Question',
        AddressLocation: 'Address/Location',
        CitySelection: 'City Selection',
        Timing: 'Timing',
        MatrixTypeQuestions: 'Matrix Type Question',
        MatrixRadioSelection: 'Matrix Radio Selection',
        CellPhoneNumber: 'Cell Phone Number',
        MatrixMultipleSelection: 'Matrix Multiple Selection',
        MatrixStarRating: 'Matrix Star Rating',
        MatrixFillingInTheBlank: 'Matrix Filling in the Blank',
        FillInTheBlankWithMultipleRowsOfMatrix: 'Fill in the Blank with Multiple Rows in the Matrix',
        MatrixCombination: 'Matrix Combination',
        MoreQuestionTypes: 'More Question Types',
        Headings: 'Headings',
        Paging: 'Page Breaker',
        PersonalInformation: 'Personal Information',
        SingleLineInputBox: 'Single Line Input Box',
        Career: 'Career',
        UploadFiles: 'Upload Files',
        FillInTheBlankHorizontally: 'Fill in the Blank Horizontally',
        MultipleBlankFilling: 'Multiple Blanks Filling',
        CascadeQuestions: 'Cascade Question',
        SpecificGravityQuestion: 'Specific Gravity Question',
        ScaleQuestions: 'Scale Question',
        MultilineInputBox: 'Multiline Input Box',
        FillInTheBlanks: 'Fill in the Blanks',
        PictureSelection: 'Picture Selection',
        MultipleChoiceQuestions: 'Multiple Choice Question',
        MultipleChoice: 'Multiple Choice',
        DropDownList: 'Drop Down List',
        AnswerSheetDetails: 'Answer Sheet Details',
        AnswerInformation: 'Answer Information',
        TotalScore: 'Total Score',
        TextReading: 'Text Reading',
        AnswerSheetReading: 'Answer Sheet Reading',
        ViewAttachments: 'View Attachments',
        Photo: 'Photo',
        NoPicturesObtained: 'No Image Obtained',
        SoundRecording: 'Sound Recording',
        AudioNotSupported: 'Your browser does not support audio elements.',
        Positioning: 'positioning',
        LocationNotObtained: 'No location information Obtained',
        IncompleteData: 'Incomplete Data, Please Refresh the Page',
        SampleNumber: 'Sample Number'
    },
  };